/**
 * Runs polyfills only on the client
 */
export function UseClientPolyfills() {
  if (IS_SERVER) return;
  UseIdleCallbackPolyfill();
}

/**
 * Polyfills useIdleCallback with setTimeout
 * useIdleCallback is undefined on Safari
 */
function UseIdleCallbackPolyfill() {
  window.requestIdleCallback =
    window.requestIdleCallback ??
    ((...params: Parameters<typeof window.requestIdleCallback>) =>
      setTimeout(params[0], params?.[0]?.['timeout'] ?? 1000));
}
